export default {
  bookings: [],
  selectedDate: new Date(),
  searchString: '',
  customerSuggestions: [],
  loading: false,
  isDirty: false,
};
